import React, { useState, useCallback } from 'react';
import { publishArticle } from './api';
import useCsrfToken from './hooks/useCsrfToken';
import useArticleStore from './stores/useArticleStore';
import { useTranslations } from './contexts/TranslationContext';
import PreviewModal from './PreviewModal';
import SharedPublishPanel from '../shared/PublishPanel';

export default function PublishPanel({ saveNow, compact }) {
  var t = useTranslations();
  var csrfToken = useCsrfToken();
  var isPublishingState = useState(false);
  var isPublishing = isPublishingState[0];
  var setIsPublishing = isPublishingState[1];

  var id = useArticleStore(function(s) { return s.id; });
  var slug = useArticleStore(function(s) { return s.slug; });
  var autosaveToken = useArticleStore(function(s) { return s.autosave_token; });
  var published = useArticleStore(function(s) { return s.published; });
  var hasPublishRecord = useArticleStore(function(s) { return s.has_publish_record; });
  var saveStatus = useArticleStore(function(s) { return s.saveStatus; });
  var publishErrors = useArticleStore(function(s) { return s.publishErrors; });
  var setPublishErrors = useArticleStore(function(s) { return s.setPublishErrors; });

  var saving = saveStatus === 'saving' || isPublishing;

  var handleSaveDraft = useCallback(function() {
    if (saveNow) saveNow();
  }, [saveNow]);

  var handlePublish = useCallback(function() {
    if (!id || isPublishing) return;
    setPublishErrors({});
    setIsPublishing(true);

    publishArticle(csrfToken, id, autosaveToken)
      .then(function(result) {
        if (result.status === 422 && result.data.errors) {
          setPublishErrors(result.data.errors);
        } else if (result.data.success) {
          window.location.href = result.data.redirect_url || '/articles';
        } else {
          setPublishErrors({ base: [result.data.error || 'Publish failed'] });
        }
      })
      .catch(function() {
        setPublishErrors({ base: ['An unexpected error occurred'] });
      })
      .finally(function() {
        setIsPublishing(false);
      });
  }, [id, autosaveToken, csrfToken, isPublishing, setPublishErrors]);

  return (
    <SharedPublishPanel
      id={id}
      slug={slug}
      published={published}
      hasPublishRecord={hasPublishRecord}
      saveStatus={saveStatus}
      publishErrors={publishErrors}
      setPublishErrors={setPublishErrors}
      onSaveDraft={handleSaveDraft}
      onPublish={handlePublish}
      saving={saving}
      isPublishing={isPublishing}
      deleteUrl={'/articles/' + (slug || id)}
      deleteTitle={t.delete_article}
      deleteConfirm={t.delete_confirm}
      PreviewComponent={PreviewModal}
      previewIdProp="articleId"
      translations={t}
      compact={compact}
    />
  );
}
